const destinations = [
  { name: "Germany", context: "Engineering co-ops at BMW, Siemens, and Bosch; AU faculty research collaborations; veterinary exchange programs", urgency: "Co-op start dates are fixed — passport delays cost students an entire semester", icon: "ri-map-pin-2-line" },
  { name: "United Kingdom", context: "Academic conferences at Oxford and Imperial College; business travel from Lee County manufacturing firms", urgency: "Conference registration requires confirmed travel 4–8 weeks out; passport issues discovered late", icon: "ri-map-pin-2-line" },
  { name: "Kenya & East Africa", context: "AU veterinary One Health research; study-abroad programs; medical and veterinary mission trips", urgency: "Field research windows are narrow and seasonally constrained", icon: "ri-map-pin-2-line" },
  { name: "Japan", context: "AU engineering research partnerships; technology company co-ops; international academic exchanges", urgency: "Japanese visa requirements add processing time — passport must be in hand first", icon: "ri-map-pin-2-line" },
  { name: "Costa Rica & Latin America", context: "AU agriculture and veterinary fieldwork; study-abroad programs; family ecotourism from the AU community", urgency: "Fieldwork windows are set months in advance but passport checks often happen last-minute", icon: "ri-map-pin-2-line" },
  { name: "Canada", context: "Niagara Falls family trips, research collaborations, and Toronto-area academic conferences for AU faculty", urgency: "Summer family travel books fast — expired passports discovered at booking", icon: "ri-map-pin-2-line" },
];

const stats = [
  { stat: "Jan & Aug", label: "peak months when study-abroad acceptances and co-op start dates drive Auburn passport urgencies" },
  { stat: "60–90 mi", label: "to the nearest regional passport agency — Atlanta or Montgomery — making expedited courier essential" },
  { stat: "30,000+", label: "Auburn University students, many traveling internationally for the first time with hard program deadlines" },
  { stat: "4–8 Weeks", label: "typical notice Auburn students and faculty have before a study-abroad or research departure" },
];

export default function AuburnDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Auburn Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from East Alabama clients. Understanding Auburn's academic and research travel culture is part of why our document review catches issues before they derail a study-abroad semester or research trip.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Alabama Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">We serve travelers across Alabama with the same expedited passport processing and document review expertise.</p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              {[{ name: "Birmingham", href: "/cities/birmingham" }, { name: "Montgomery", href: "/cities/montgomery-al" }, { name: "Huntsville", href: "/cities/huntsville" }].map((link) => (
                <a key={link.href} href={link.href} className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                  {link.name} <i className="ri-arrow-right-line text-xs"></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}